/* eslint-disable jsx-a11y/alt-text */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { z } from 'zod';
import { DataNotFound } from '../../../components/DataNotFound';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';
import { PageHitCountApi } from '../../../shared/Helper';
import { defaultImage } from '../../../constants';
import ShareIcon from '@mui/icons-material/Share';
import copy from 'copy-to-clipboard';
import LoadingAnimation from '../../../components/LoadingAnimation';
import Banners from '../../../components/elements/Banners';
import baseURL, { getAsync, postAsync, reactURL } from '../../../components/helper/axiosHelper';
import useFetch from '../../../hooks/useFetch/useFetch';
import CircularProgress from '@mui/material/CircularProgress';
const ExternalPayment = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const location = useLocation();
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [datanotfound, setDatanotfound] = useState(false);
  const [emiratesAPIData, setEmiratesAPIData] = useState([]);
  const [epUserID, setEpUserID] = useState(null);
  const [senderUserId, setSenderUserId] = useState(0);
  const [formerror, setFormerror] = useState({});
  const [amount, setAmount] = useState('');

  const { t } = useTranslation();
  const token = localStorage.getItem('token');
  const { id, refferalLink, pid, projectTypeIdInt } = useParams();

  const COUNTRIES = `${baseURL}/Utilities/GetCountryList`;
  const { loading: countryLoading, error: countryError, value: countryData } = useFetch(COUNTRIES, {}, []);
  const { paymentInfo } = location.state || {};
  const [paymentObject, setPaymentObject] = useState({
    amount: paymentInfo?.amount,
    donorName: '',
    projectNameByDonor: '',
    countryId: '208',
    emirates: '3',
    phone: '',
    email: '',
  });

  // const userinfo = z
  //   .object({
  //     email: z
  //       .string()
  //       .email('Please provide a valid email')
  //       .refine((value) => value.trim() !== '', {
  //         message: 'Email is required',
  //       }),
  //     mobile: z
  //       .string()
  //       .min(5, 'Number must contain min 5 digits')
  //       .max(50, 'Number must contain max  50 digits')
  //       .refine((value) => value && /[0-9]/.test(value), {
  //         message: 'Mobile number is required',
  //       }),
  //     donorNameByDonor: z
  //       .string()
  //       .min(3, 'Must be 3 or more characters long')
  //       .max(50, 'Must be 50 characters long')
  //       .refine((value) => value || /[a-z]/.test(value), 'Donor Name is required')
  //       .refine((value) => value || /[A-Z]/.test(value), 'Donor Name is required'),
  //     projectNameByDonor: z
  //       .string()
  //       .min(3, 'Must be 3 or more characters long')
  //       .max(50, 'Must be 50 characters long')
  //       .refine((value) => value || /[a-z]/.test(value), 'Project Name By Donor is required')
  //       .refine((value) => value || /[A-Z]/.test(value), 'Project Name By Donor is required'),
  //     countryId: z.string().refine((value) => value > '0', {
  //       message: 'Country is required',
  //     }),
  //     emirate: z.string().optional(),
  //   })
  //   .refine(
  //     (data) => {
  //       if (data.countryId === '208' && !data.emirate) {
  //         return false;
  //       }
  //       return true;
  //     },
  //     {
  //       message: 'Emirate is required when country is UAE',
  //       path: ['emirates'],
  //     },
  //   );
  const getValidationSchema = (pid) => {
    let schema = z.object({
      email: z.string().optional(),
      // .email('Please provide a valid email')
      // .refine((value) => value.trim() !== '', {
      //   message: 'Email is required',
      // }),
      countryId: z.string().refine((value) => value > '0', {
        message: 'Country is required',
      }),
      emirate: z.string().optional(),
    });

    if (pid == 8) {
      schema = schema.extend({
        donorNameByDonor: z
          .string()
          .min(3, 'Must be 3 or more characters long')
          .max(50, 'Must be 50 characters long')
          .nonempty('Donor Name is required'),
        mobile: z
          .string()
          .min(5, 'Number must contain min 5 digits')
          .max(50, 'Number must contain max 50 digits')
          .regex(/[0-9]/, 'Mobile number is required'),
        projectNameByDonor: z
          .string()
          .min(3, 'Must be 3 or more characters long')
          .max(50, 'Must be 50 characters long')
          .nonempty('Project Name By Donor is required'),
      });
    } else if (pid == 9) {
      schema = schema.extend({
        donorNameByDonor: z.string().nonempty('Donor Name is required'),
        mobile: z.string().nonempty('Mobile number is required'),
      });
    } else if ([10, 11, 14, 12, 13].includes(Number(pid))) {
      schema = schema.extend({
        mobile: z.string().nonempty('Mobile number is required'),
      });
    } else {
      schema = schema.extend({
        donorNameByDonor: z.string().nonempty('Donor Name is required'),
        mobile: z.string().nonempty('Mobile number is required'),
        email: z.string().nonempty('Email is required'),
      });
    }

    return schema;
  };

  const userinfo = getValidationSchema(pid);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setPaymentObject((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // const getProjectData = async () => {
  //   setDatanotfound(false);
  //   setIsLoad(true);
  //   await postAsync('APIClient/ProjectListGUID', [id])
  //     .then((response) => {
  //       const result = response?.data;
  //       setApiData(result);
  //       setPaymentObject((prevState) => ({
  //         ...prevState,
  //         projectNameByDonor: isActive ? result[0]?.titleAr : result[0]?.titleEn,
  //       }));
  //       setIsLoad(false);
  //       if (response?.statusCode == 204) {
  //         setDatanotfound(true);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       toast.error(t('Something went wrong, Please try again!'));
  //       setIsLoad(false);
  //       setDatanotfound(true);
  //     });
  // };
  const getProjectData = async () => {
    setDatanotfound(false);
    setIsLoad(true);
    await postAsync('APIClient/ProjectListGUID', [{ ProjectId: id, ProjectTypeIdInt: projectTypeIdInt }])
      .then((response) => {
        const result = response?.data;
        setApiData(result);
        // Remove this line to keep projectNameByDonor empty by default
        // setPaymentObject((prevState) => ({
        //   ...prevState,
        //   projectNameByDonor: isActive ? result[0]?.titleAr : result[0]?.titleEn,
        // }));
        setIsLoad(false);
        if (response?.statusCode == 204 || response?.statusCode == 500) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
        setIsLoad(false);
        setDatanotfound(true);
      });
  };
  const getEmirates = async () => {
    await getAsync('Utilities/GetEmiratesList')
      .then((response) => {
        const result = response?.data;
        setEmiratesAPIData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  let axiosConfig = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const getUserData = async () => {
    await getAsync('EP_UserAuthentication/EPUserByID/', { id: epUserID }, axiosConfig)
      .then((response) => {
        const result = response?.data[0];
        // setApiData(result);
        if (result) {
          setPaymentObject((prevState) => ({
            ...prevState,
            donorName: result?.fullName || '',
            email: result?.email || '',
            phone: result?.mobile || '',
          }));
        }
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', true);
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
    //getppProjectData();

    if (token) {
      if (epUserID !== null) {
        getUserData();
        PageHitCountApi(location.pathname, epUserID);
      }
      localStorage.setItem('isHome', false);
    } else {
      localStorage.setItem('isHome', true);
    }

    getEmirates();
    getProjectData();
  }, [refferalLink, epUserID]);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (!role) {
      PageHitCountApi(location.pathname, 0);
    }

    if (role && epUserID != null && epUserID != 0) {
      PageHitCountApi(location.pathname, epUserID);
    }
  }, [epUserID]);

  useEffect(() => {
    (async () => {
      if (pid != 6 || pid != 7) {
        const api = `Utilities/GetEPUserIDByRefferalLinkAndProcessID?ProcessID=${pid}&RefferalLink=${refferalLink}`;
        await getAsync(api)
          .then((response) => {
            const result = response;
            setSenderUserId(result?.epUserID);
            // setCountryAPIData(result);
          })
          .catch((error) => {
            // toast.error(`${t('Failed to fetch countries, Error Due to:', error.message)}`);
          });
      }
    })();
    setAmount(paymentInfo?.amount.toString());
  }, []);
  // useEffect(() => {
  //   if (apiData.length > 0) {
  //     console.log('iamiuncondiion');
  //     setPaymentObject((prevState) => ({
  //       ...prevState,
  //       projectNameByDonor: isActive ? apiData[0]?.titleAr : apiData[0]?.titleEn,
  //     }));
  //   }
  // }, [apiData]);

  // amount: paymentInfo?.amount?.toString() ?? 0,
  const finalAmount = amount && amount > 0 ? amount : paymentInfo?.amount?.toString();
  // const paymentData = {
  //   moduleID: '5',
  //   projectID: apiData?.[0]?.id ?? [],
  //   amount: finalAmount,
  //   moduleName: apiData[0]?.projectType || 'Public',
  //   projectName: apiData[0]?.titleAr || apiData[0]?.titleEn,
  //   projectNameByDonor: paymentObject?.projectNameByDonor || '',
  //   donorNameByDonor: paymentObject?.donorName,
  //   donorProjectName: apiData[0]?.titleAr || apiData[0]?.titleEn,
  //   userID: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
  //   comments: '',
  //   firstName: '',
  //   lastName: '',
  //   emirate: paymentObject?.emirates,
  //   mobile: paymentObject?.phone,
  //   email: paymentObject?.email,
  //   isGift: pid == 7 ? true : false,
  //   giftedPersonName: pid == 7 ? paymentObject?.donorName : '',
  //   giftedPersonNumber: pid == 7 ? paymentObject?.phone : '',
  //   giftedPersonEmail: pid == 7 ? paymentObject?.email : '',
  //   countryId: paymentObject?.countryId,
  //   cityId: 0,
  //   recuringType: paymentInfo?.paymentMethodId?.toString(),
  //   isFromCart: false,
  //   middleName: '',
  //   giftType: 0,
  //   sponsorshipNoOfYears: 0,
  //   isRecurring: true,
  //   recurringTenure: 0,
  //   afterPaymentReturnPath: '',
  //   userIdNumber: epUserID ?? 0,
  //   processID: pid,
  //   refferalLink: refferalLink ?? null,
  //   registerUserID: senderUserId,
  //   projectTypeIdInt,
  // }

  const paymentData = {
    moduleID: '5',
    projectID: apiData?.[0]?.id ?? null,
    amount: finalAmount,
    moduleName: apiData?.[0]?.projectType || 'Public',
    projectName: apiData?.[0]?.titleAr || apiData?.[0]?.titleEn || '',
    projectNameByDonor: paymentObject?.projectNameByDonor || '',
    donorNameByDonor: paymentObject?.donorName,
    donorProjectName: apiData?.[0]?.titleAr || apiData?.[0]?.titleEn || '',
    userID: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    comments: '',
    firstName: '',
    lastName: '',
    emirate: paymentObject?.emirates,
    mobile: paymentObject?.phone,
    email: paymentObject?.email,
    isGift: pid == 7,
    giftedPersonName: pid == 7 ? paymentObject?.donorName : '',
    giftedPersonNumber: pid == 7 ? paymentObject?.phone : '',
    giftedPersonEmail: pid == 7 ? paymentObject?.email : '',
    countryId: paymentObject?.countryId,
    cityId: 0,
    recuringType: paymentInfo?.paymentMethodId?.toString(),
    isFromCart: false,
    middleName: '',
    giftType: 0,
    sponsorshipNoOfYears: 0,
    isRecurring: true,
    recurringTenure: 0,
    afterPaymentReturnPath: '',
    userIdNumber: epUserID ?? 0,
    processID: pid,
    refferalLink: refferalLink ?? null,
    registerUserID: senderUserId,
    projectTypeIdInt,
  };

  // const handlePayment = async (e) => {
  //   e.preventDefault();
  //   const userinfoparse = userinfo.safeParse(paymentData);
  //   if (!userinfoparse.success) {
  //     const error = userinfoparse.error;
  //     let newerror = {};
  //     for (const issue of error.issues) {
  //       newerror = { ...newerror, [issue.path]: issue.message };
  //     }

  //     return setFormerror(newerror);
  //   } else {
  //     if (amount !== '') {
  //       if (amount > 0) {
  //         await postAsync(`APIClient/PaymentRequest`, paymentData)
  //           .then((response) => {
  //             localStorage.setItem('isPayment', true);
  //             window.location.href = response?.paymentPortal;
  //           })
  //           .catch((err) => {
  //             console.log('err responsePayment', err);
  //           });
  //       } else {
  //         toast.error('amount must be greater than or equal to 0');
  //       }
  //     } else if (amount === '') {
  //       await postAsync(`APIClient/PaymentRequest`, paymentData)
  //         .then((response) => {
  //           localStorage.setItem('isPayment', true);
  //           window.location.href = response?.paymentPortal;
  //         })
  //         .catch((err) => {
  //           console.log('err responsePayment', err);
  //         });
  //     }
  //   }
  // };

  // const handleCopy = () => {
  //   const campaignRefferalLink = `${reactURL}/PaymentProcess/` + refferalLink + '/' + refferalLink + '/' + pid;
  //   copy(campaignRefferalLink);
  //   toast.success(t('Link copy Successfully'));
  // }

  const handlePayment = async (e) => {
    e.preventDefault();
    const userinfoparse = userinfo.safeParse(paymentData);
    if (!userinfoparse.success) {
      const error = userinfoparse.error;
      let newerror = {};
      for (const issue of error.issues) {
        newerror = { ...newerror, [issue.path]: issue.message };
      }
      setFormerror(newerror);
    } else {
      if (amount !== '') {
        if (amount > 0) {
          setIsPaymentLoading(true); // Set loading state to true
          try {
            const response = await postAsync(`APIClient/PaymentRequest`, paymentData);
            localStorage.setItem('isPayment', true);
            window.location.href = response?.paymentPortal;
          } catch (err) {
            console.log('err responsePayment', err);
            toast.error(t('Something went wrong, Please try again!'));
          } finally {
            setIsPaymentLoading(false); // Reset loading state
          }
        } else {
          toast.error(t('amount must be greater than or equal to 0'));
        }
      }
      // else {
      //   setIsPaymentLoading(true); // Set loading state to true
      //   try {
      //     const response = await postAsync(`APIClient/PaymentRequest`, paymentData);
      //     localStorage.setItem('isPayment', true);
      //     window.location.href = response?.paymentPortal;
      //   } catch (err) {
      //     console.log('err responsePayment', err);
      //     toast.error(t('Something went wrong, Please try again!'));
      //   } finally {
      //     setIsPaymentLoading(false); // Reset loading state
      //   }
      // }
    }
  };
  const handleCopy = () => {
    if (pid != 7) {
      const campaignRefferalLink =
        `${reactURL}/PaymentProcess/` + refferalLink + '/' + refferalLink + '/' + pid + '/' + projectTypeIdInt;
      copy(campaignRefferalLink);
      toast.success(t('Link copy Successfully'));
    } else {
      const campaignRefferalLink = `${reactURL}/PaymentProcess/` + id + '/' + id + '/' + pid + '/' + projectTypeIdInt;
      copy(campaignRefferalLink);
      toast.success(t('Link copy Successfully'));
    }
  };

  return (
    <div>
      <Banners />
      <div className="">
        {isLoad ? (
          <LoadingAnimation
            imageStyling={''}
            styling={'flex items-center py-5 align-middle justify-center space-x-2'}
          />
        ) : (
          apiData?.length > 0 && (
            <div className="h-full rounded-xl border text-left items-start p-10">
              {apiData?.map((data, index) => (
                <>
                  <div key={index} className="flex rounded-xl flex-col md:flex-row">
                    <div className="w-full rounded-xl md:m-10 flex flex-col items-center justify-center md:w-70 ">
                      {pid == '9' ? (
                        paymentInfo?.familyMembersCount > 0 ? (
                          <img
                            className="w-auto md:h-3/5 lg:h-4/5 align-middle rounded-xl justify-center"
                            src={'/assets/sponsor_images/Family.png'}
                            alt="project Name"
                          />
                        ) : (
                          <img
                            className="w-auto md:h-3/5 lg:h-4/5 align-middle rounded-xl justify-center"
                            src={`${paymentInfo?.genderNameEn == 'Male' ? '/assets/sponsor_images/Male.png' : '/assets/sponsor_images/Female.png'}`}
                            alt="project Name"
                          />
                        )
                      ) : (
                        <img
                          src={`data:image/jpeg;base64,${apiData[0]?.imagePath || defaultImage}`}
                          className="w-auto md:h-3/5 lg:h-4/5 align-middle rounded-xl justify-center"
                        />
                      )}

                      <div className="flex flex-col justify-center items-center">
                        <h2 className="sm:text-2xl font-bold rtl:text-right py-4 ">
                          {t(`${isActive ? data?.titleAr : data?.titleEn}`)}{' '}
                        </h2>
                        <h2 className="text-xl font-bold rtl:text-right py-4">
                          {t(`${isActive ? data?.descriptionAr : data?.descriptionEnglish}`)}{' '}
                        </h2>
                      </div>
                    </div>

                    <div className="w-full border flex flex-col justify-center items-center bg-green-50 rounded-xl py-10 lg:w-3/4 px-4">
                      <h2 className="sm:text-2xl font-bold  mb-4">
                        {t(`${isActive ? data?.titleAr : data?.titleEn}`)}{' '}
                      </h2>
                      <div className="justify-center items-center text-center">
                        <h3 className="text-xl font-bold mb-4">{t('Amount')}</h3>
                        <h3 className="text-xl text-red-300 font-bold mb-4">{paymentInfo?.amount}</h3>
                      </div>

                      <form className="w-full">
                        {/* <div className="mb-4">
                          <input
                            id="amount"
                            name="amount"
                            type="text"
                            value={paymentInfo?.isContribution ? paymentInfo?.amount : amount}
                            onInput={(event) => {
                              const { value } = event.target;
                              const regex = /^(0|[1-9]\d*)(\.\d{1,2})?$/;

                              if (regex.test(value) || value === '') {
                                setAmount(value);
                              } else {
                                event.target.value = value.replace(/\D/g, '');
                              }
                            }}
                            className={`items-left ${paymentInfo?.isContribution && 'cursor-not-allowed'} w-full px-4 py-2 border border-gray-300 focus:ring-customgreen hover:focus:border-customgreen rounded-md`}
                            placeholder={t('Enter Amount')}
                            maxLength={7}
                            min="0"
                            disabled={paymentInfo?.isContribution}
                          />
                          {formerror.amount && (
                            <p className={`${isActive ? 'text-right text-red-700 ' : 'text-left text-red-700 '}`}>
                              {t(formerror.amount)}
                            </p>
                          )}
                        </div> */}
                        <div className="mb-4">
                          <input
                            placeholder={t('Donor Name')}
                            type="text"
                            id="donorName"
                            className="items-left  w-full px-4 py-2 border border-gray-300 focus:ring-customgreen hover:focus:border-customgreen rounded-md"
                            name="donorName"
                            value={paymentObject?.donorName}
                            onChange={(e) => handleOnChange(e)}
                          />
                          {formerror.donorNameByDonor && (
                            <p className={`${isActive ? 'text-right text-red-700 ' : 'text-left text-red-700 '}`}>
                              {t(formerror.donorNameByDonor)}
                            </p>
                          )}
                        </div>
                        {pid == 8 && (
                          <div className="mb-4">
                            <input
                              placeholder={t('Project Name')}
                              type="text"
                              id="projectName"
                              className="w-full items-start px-4 py-2 border border-gray-300 focus:ring-customgreen hover:focus:border-customgreen rounded-md"
                              name="projectNameByDonor"
                              value={paymentObject?.projectNameByDonor}
                              onChange={(e) => handleOnChange(e)}
                            />
                            {formerror.projectNameByDonor && (
                              <p className={`${isActive ? 'text-right text-red-700 ' : 'text-left text-red-700 '}`}>
                                {t(formerror.projectNameByDonor)}
                              </p>
                            )}
                          </div>
                        )}
                        <div className="mb-4">
                          <select
                            disabled="true"
                            id="country"
                            className="w-full px-4 items-start py-2 border border-gray-300 focus:ring-customgreen hover:focus:border-customgreen rounded-md cursor-not-allowed"
                            name="countryId"
                            value={paymentObject.countryId}
                            onChange={(e) => handleOnChange(e)}
                          >
                            {countryData?.data?.map((item) => (
                              <option key={item.countryID} value={item.countryID}>
                                {isActive ? item?.ar_SA : item.countryName}
                              </option>
                            ))}
                          </select>
                        </div>

                        {paymentObject?.countryId == 208 && pid == 6 && (
                          <>
                            <div className="mb-4">
                              <select
                                id="emirates"
                                className="w-full px-4   items-start py-2 border border-gray-300 focus:ring-customgreen hover:focus:border-customgreen rounded-md"
                                name="emirates"
                                value={paymentObject.emirates}
                                onChange={(e) => handleOnChange(e)}
                              >
                                <option value={''}>--{t('SELECT EMIRATES')}--</option>
                                {emiratesAPIData?.map((item) => {
                                  return (
                                    <option key={item.emiratesID} value={item.emiratesID}>
                                      {t(isActive ? item?.ar_SA : item?.en_US)}
                                    </option>
                                  );
                                })}
                              </select>
                              {formerror.emirates && (
                                <p className={`${isActive ? 'text-right text-red-700 ' : 'text-left text-red-700 '}`}>
                                  {t(formerror.emirates)}
                                </p>
                              )}
                            </div>
                          </>
                        )}
                        <div className="mb-4 gap-3 ">
                          <input
                            placeholder={t('Mobile') + ' ' + `(${t('Your mobile number should starts with +971.')})`}
                            type="text"
                            maxLength={13}
                            id="phoneNumber"
                            className="w-full px-4  py-2 border border-gray-300 focus:ring-customgreen hover:focus:border-customgreen rounded-md"
                            name="phone"
                            value={paymentObject?.phone}
                            onChange={(e) => handleOnChange(e)}
                            onInput={(event) => {
                              const { value } = event.target;
                              const regex = /^\+?\d*$/;

                              if (regex.test(value)) {
                              } else {
                                event.target.value = value.slice(0, -1);
                              }
                            }}
                          />
                          {formerror.mobile && (
                            <p className={`${isActive ? 'text-right text-red-700 ' : 'text-left text-red-700 '}`}>
                              {t(formerror.mobile)}
                            </p>
                          )}
                        </div>

                        <div className="mb-4">
                          <input
                            placeholder={t('Email')}
                            type="email"
                            id="email"
                            className="w-full px-4  items-start py-2 border border-gray-300 focus:ring-customgreen hover:focus:border-customgreen rounded-md"
                            name="email"
                            value={paymentObject?.email}
                            onChange={(e) => handleOnChange(e)}
                          />
                          {formerror.email && (
                            <p className={`${isActive ? 'text-right text-red-700 ' : 'text-left text-red-700 '}`}>
                              {t(formerror.email)}
                            </p>
                          )}
                        </div>
                        {/* <div className="flex gap-3 items-center mb-4 py-4 justify-center ">
                          <button className="" onClick={handlePayment}>
                            <img src="/assets/images/cardPaymentDouble.png" alt="card pay double" />
                          </button>
                          <button className="" onClick={handlePayment}>
                            <img src="/assets/images/applePay.png" alt="apple pay" />
                          </button>
                          <button className="" onClick={handlePayment}>
                            <img src="/assets/images/samsungPay.png" alt="samsung pay" />
                          </button>
                        </div> */}
                        <div className="flex gap-3 items-center mb-4 py-4 justify-center">
                          {isPaymentLoading ? (
                            <CircularProgress className="!text-customgreen" />
                          ) : (
                            <>
                              <button className="" onClick={handlePayment}>
                                <img src="/assets/images/cardPaymentDouble.png" alt="card pay double" />
                              </button>
                              <button className="" onClick={handlePayment}>
                                <img src="/assets/images/applePay.png" alt="apple pay" />
                              </button>
                              <button className="" onClick={handlePayment}>
                                <img src="/assets/images/samsungPay.png" alt="samsung pay" />
                              </button>
                            </>
                          )}
                        </div>
                        <div className="flex items-center  justify-center">
                          <button
                            onClick={handleCopy}
                            type="button"
                            className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-md text-sm px-3 py-2 text-center"
                          >
                            {t('Share')}
                            <ShareIcon className={`w-7 h-7 items-center cursor-pointer text-white  mx-2  `} />
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              ))}
            </div>
          )
        )}{' '}
      </div>
      {datanotfound && <DataNotFound />}
    </div>
  );
};

export default ExternalPayment;
